import { render, staticRenderFns } from "./how-to-buy-netone-airtime-using-ecocash.vue?vue&type=template&id=4d37d649"
import script from "./how-to-buy-netone-airtime-using-ecocash.vue?vue&type=script&lang=js"
export * from "./how-to-buy-netone-airtime-using-ecocash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports